import React, { useState } from 'react';
import { FilterCategory, FilterCategoryItem } from './categories';
import { FilterInputKeywords, FilterInputLocation, FilterInputDistance } from './inputs';
import { AlertFrequency } from './AlertFrequency';
import { transformCategories } from '../../helpers';

const APPLICATION_TYPE = {
  id: '0',
  name: 'Quick Apply',
  queryStringId: 'applicationType=quick-apply',
  queryAs: 'quick-apply',
  children: [],
};

export const Filters = () => {
  const [categories, setCategories] = useState(transformCategories());

  const onChange = (name, status) => {
    let categoryList = [...categories];

    categoryList = categoryList.map((item) => {
      item.active = false;

      if (item.name === name) {
        item.active = status;
      }

      return item;
    });

    setCategories(categoryList);
  };

  const firstList = categories.slice(0, 5);
  const secondList = categories.slice(5, categories.length);

  return (
    <div className="tds-alert__filters">
      <div className="tds-alert__filters__inputs">
        <FilterInputKeywords />
        <div className="tds-alert__filters__inputs__location">
          <FilterInputLocation />
          <FilterInputDistance />
        </div>
      </div>
      <AlertFrequency />
      <div className="tds-alert__filters__application-type">
        <FilterCategoryItem item={APPLICATION_TYPE} isApplicationType />
      </div>
      <div className="tds-alert__filters__categories">
        <div className="tds-alert__filters__categories--left">
          {firstList.map((category) => (
            <FilterCategory key={category.name} category={category} onChange={onChange} />
          ))}
        </div>
        <div className="tds-alert__filters__categories--right">
          {secondList.map((category) => (
            <FilterCategory key={category.name} category={category} onChange={onChange} />
          ))}
        </div>
      </div>
    </div>
  );
};
